import React, { useCallback, createContext } from 'react';
import { ContratoDisponivelEntidade, EmprestimoSimulacaoParametros } from '@entidades';

interface IEmprestimoSimuladorContext {
  salvarParametros: (parametros: EmprestimoSimulacaoParametros) => void;
  buscarParametros: () => Promise<EmprestimoSimulacaoParametros>;

  salvarContratoDisponivel: (contrato: ContratoDisponivelEntidade) => void;
  buscarContratoDisponivel: () => Promise<ContratoDisponivelEntidade>;
}

export const EmprestimoSimuladorContext = createContext<IEmprestimoSimuladorContext | null>(null);

export const EmprestimoSimuladorProvider: React.FC = ({ children }) => {
  const salvarParametros = useCallback(async (parametros) => {
    const parametrosString = JSON.stringify(parametros);
    await localStorage.setItem('EmprestimoSimulacaoParametros', parametrosString);
  }, []);

  const buscarParametros = useCallback(async () => {
    const parametrosString = await localStorage.getItem('EmprestimoSimulacaoParametros');
    return JSON.parse(parametrosString) as EmprestimoSimulacaoParametros;
  }, []);

  const salvarContratoDisponivel = useCallback(async (parametros) => {
    const parametrosString = JSON.stringify(parametros);
    await localStorage.setItem('ContratoDisponivelSelecionado', parametrosString);
  }, []);

  const buscarContratoDisponivel = useCallback(async () => {
    const parametrosString = await localStorage.getItem('ContratoDisponivelSelecionado');
    return JSON.parse(parametrosString) as ContratoDisponivelEntidade;
  }, []);

  return (
    <EmprestimoSimuladorContext.Provider value={{ salvarParametros, buscarParametros, salvarContratoDisponivel, buscarContratoDisponivel }}>
      {children}
    </EmprestimoSimuladorContext.Provider>
  );
};
